import React, { useEffect } from 'react';
import { useAuth } from '@contexts/AuthContext';
import AuthenticatedResults from '@components/results/AuthenticatedResults';
import GuestResults from '@components/results/GuestResults';
import type { ReadOnlyFormProps } from '../../types/form.types';

interface ResultsPageProps extends ReadOnlyFormProps {
  onRetake?: () => void;
}

const ResultsPage: React.FC<ResultsPageProps> = ({ formData, onRetake }) => {
  const { isAuthenticated } = useAuth();

  // Scroll to top when results page opens
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // Render different components based on authentication status
  if (isAuthenticated) {
    return <AuthenticatedResults formData={formData} />;
  }

  return <GuestResults formData={formData} onRetake={onRetake} />;
};

export default ResultsPage;
